"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestClientSchema = void 0;
/**
 *  The validation schema for a request client.
 */
exports.RequestClientSchema = {
    $id: '#request-client',
    type: 'object',
    additionalProperties: false,
    /**
     *  Default required properties,
     */
    required: [
        'salutation',
        'first_name',
        'last_name',
        'phone_number',
        'email_address',
    ],
    /**
     *  The properties.
     */
    properties: {
        salutation: { type: 'string', enum: ['Dhr.', 'Mevr.', 'Overig', 'Onbekend'] },
        first_name: { type: 'string', minLength: 3, pattern: "[a-z\u00C0-\u00FF -'`’.]" },
        last_name: { type: 'string', minLength: 3, pattern: "[a-z\u00C0-\u00FF -'`’.]" },
        phone_number: { type: 'string', pattern: "[(]?[+]?[0-9]{2,3}[)]?[-\s]?[0-9\s]{8,12}" },
        email_address: { type: 'string', pattern: "\\S+@\\S+\\.\\S+" },
        address: { type: 'object', $ref: '#request-address' },
        request: { type: ['string', 'null'] },
    },
    /**
     *  Error messages.
     */
    errorMessage: {
        properties: {
            salutation: '',
            first_name: 'Ongeldige voornaam',
            last_name: 'Ongeldige achternaam',
            phone_number: 'Ongeldig telefoonnummer',
            email_address: 'Ongeldig e-mailadres',
        },
    },
};
//# sourceMappingURL=client.schema.js.map